import { createSlice } from "@reduxjs/toolkit";

const indicesSlice = createSlice({
  name: "indices",
  initialState: [],
  reducers: {
    setIndices: (state, action) => {
      return action.payload;
    },
  },
});

export const { setIndices } = indicesSlice.actions;
export default indicesSlice.reducer;
